export const extraCareServiceName = 'JB Hi-Fi Extra Care';

export enum ServiceIds {
  AppleCareNz = 'apple-care-nz', //Apple Care NZ
  MobileExtras = 'mobile-extras', //JB Hi-Fi Extras AU
  ExtraCare = 'extended-care', //JB Hi-Fi Extra Care AU
  ExtraCareNz = 'extended-care-nz', //JB Hi-Fi Extra Care NZ
}
